/**
 * Компонент выпадающего списка с опциями, label и error сообщениями
 */
import { forwardRef, SelectHTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: { value: string; label: string }[];
  testId?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, options, testId, className, ...props }, ref) => {
    return (
      <div>
        {label && (
          <label className="block text-sm font-medium text-shell-text mb-1.5">
            {label}
          </label>
        )}
        <select
          ref={ref}
          data-testid={testId}
          className={cn(
            'shell-select',
            error && 'border-shell-danger focus:!border-shell-danger',
            className
          )}
          {...props}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {error && (
          <span className="text-shell-danger text-sm mt-1 block">{error}</span>
        )}
      </div>
    );
  }
);

Select.displayName = 'Select';

